module.exports = __webpack_public_path__ + "img/ticket30.152bcfee.png";